export default {
  data() {
    return {
      replaceString: '<mark class="highlight">$&</mark>'
    }
  },

  props: {
    searchText: {
      type   : String,
      default: ''
    }
  },

  computed: {
    langSearchText() {
      return this.searchText || this.searchTerms || ''
    }
  },

  methods: {
    textNormalizeAccents(s) {
      return s
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^\p{L}\p{N}\s]/gu, '')
    },

    textSearchHighlight(text, normalize = false, highlight = false) {
      if (!highlight || !this.langSearchText) return text || ''

      if (normalize) return this.textSearchHighlightNormalized(text)

      return this.textSearchHighlightSimple(text)
    },

    textSearchHighlightSimple(text) {
      const searchText = this.langSearchText
      const regex = new RegExp(searchText, 'gui')
      return text.replace(regex, this.replaceString)
    },

    textSearchHighlightNormalized(text) {
      const searchTextNormalized = this.textNormalizeAccents(this.langSearchText)
      const regex = new RegExp(searchTextNormalized, 'gui')
      const textNormalized = this.textNormalizeAccents(text)

      return textNormalized.replace(regex, this.replaceString)
    },

    langSearchHighlight(key, normalize = true, highlight = true) {
      return this.textSearchHighlight(this.$t(key), normalize, highlight)
    }
  }
}
